import { SET_CHAT_THEME, SET_THEME } from '../types/theme.type'

export const setTheme = (payload) => async (dispatch) => {
  localStorage.setItem('main-theme', payload)
  dispatch({
    type: SET_THEME,
    payload,
  })
}

export const setChatTheme = (payload) => async (dispatch) => {
  localStorage.setItem('chat-theme', payload)
  dispatch({
    type: SET_CHAT_THEME,
    payload,
  })
}
